export default function stripHtmlTags(
  value?: string | null
): string | null | undefined {
  return value?.toString().replace(/<\/?[^>]+(>|$)/g, '')
}
